// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Q5-D","header":"ClearentDisclaimer_header__13Yge","inner":"ClearentDisclaimer_inner__1_fyi"};